const buttons = document.querySelectorAll(".tab-button");
const contents = document.querySelectorAll(".tab-content");

function showTab(index){

buttons.forEach(btn=>btn.classList.remove("active"));

contents.forEach(tab=>tab.style.display="none");

buttons[index].classList.add("active");

contents[index].style.display="block";

}

buttons.forEach((button,index)=>{

button.addEventListener("click",()=>{

showTab(index);

current=index;

});

});

let current=0;

setInterval(()=>{

current++;

if(current>=buttons.length){

current=0;

}

showTab(current);

},5000);